<template>
  <div>
    <div id="page-user-edit" v-if="show_analytics">
      <vx-card>
        <div slot="no-body" class="tabs-container px-6 pt-6">
          <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
            <vs-tab label="Rapport Global">
              <cards-page
                title="Analytics Overview"
                :dataSource="overallData"
                :sections="[...overall_data, ...general_data]"
              ></cards-page>
            </vs-tab>
            <vs-tab label="Rapport Mensuel">
              <cards-page
                title="Monthly Analytics"
                :dataSource="monthlyData"
                :sections="overall_data"
              ></cards-page>
            </vs-tab>
            <vs-tab label="Rapport Journalier">
              <cards-page
                title="Daily Analytics"
                :dataSource="dailyData"
                :sections="overall_data"
              ></cards-page>
            </vs-tab>
            <vs-tab label="Rapport Période">
              <div class="p-6">
                <div class="vx-row mb-4">
                  <div class="vx-col w-full md:w-1/3">
                    <div class="mt-4">
                      <label class="vs-input--label">Date de début</label>
                      <flat-pickr
                        v-model="rangeStartDate"
                        :config="datePickerConfig"
                        class="w-full"
                        placeholder="Sélectionner date de début"
                      />
                    </div>
                  </div>
                  <div class="vx-col w-full md:w-1/3">
                    <div class="mt-4">
                      <label class="vs-input--label">Date de fin</label>
                      <flat-pickr
                        v-model="rangeEndDate"
                        :config="datePickerConfig"
                        class="w-full"
                        placeholder="Sélectionner date de fin"
                      />
                    </div>
                  </div>
                  <div class="vx-col w-full md:w-1/3 flex items-end">
                    <div class="mt-4 w-full">
                      <vs-button
                        @click="generateRangeReport"
                        :disabled="!rangeStartDate || !rangeEndDate || generatingRange"
                        class="w-full"
                      >
                        {{ generatingRange ? 'Génération...' : 'Générer le rapport' }}
                      </vs-button>
                    </div>
                  </div>
                </div>
                <cards-page
                  v-if="rangeData && Object.keys(rangeData).length > 0"
                  title="Range Analytics"
                  :dataSource="rangeData"
                  :sections="overall_data"
                ></cards-page>
                <div v-else class="text-center py-8 text-gray-500">
                  Sélectionnez une période et cliquez sur "Générer le rapport"
                </div>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
      </vx-card>
    </div>
    <div v-else id="loading-bg">
      <div class="loading">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
      </div>
    </div>
  </div>
</template>

<script>
import CardsPage from "@/components/custom/analytics/CardsPage.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  data() {
    return {
      overall_data: [
        {
          icon: "PackageIcon",
          title: "Articles déposés",
          key: "productCount",
          color: "warning",
        },
        {
          icon: "TagIcon",
          title: "Articles vendus",
          key: "soldCount",
        },
        {
          icon: "XIcon",
          title: "Articles retournés",
          key: "returnedCount",
          color: "danger",
        },
        {
          icon: "HeartIcon",
          title: "Articles association",
          key: "associationCount",
          color: "primary",
        },
        {
          icon: "UserCheckIcon",
          title: "Articles payés",
          key: "paidCount",
        },
        {
          icon: "UsersIcon",
          title: "Déposants",
          key: "clientCount",
        },
        {
          icon: "DollarSignIcon",
          title: "Recette Ventes",
          key: "revenues",
        },
        {
          icon: "AwardIcon",
          title: "Décaissements déposants",
          key: "payments",
          color: "success",
        },
        {
          icon: "ShoppingCartIcon",
          title: "Caisse",
          key: "comission",
          color: "danger",
        },
        {
          icon: "ShoppingCartIcon",
          title: "Bénéfice Ventes",
          key: "benefit",
          color: "danger",
        },
        {
          icon: "ShoppingCartIcon",
          title: "Paiements à venir",
          key: "futurePayments",
          color: "danger",
        },
      ],
      general_data: [
        {
          icon: "UsersIcon",
          title: "Articles Disponibles",
          key: "availableCount",
        },
      ],
      activeTab: 0,
      show_analytics: false,
      rangeStartDate: null,
      rangeEndDate: null,
      generatingRange: false,
      datePickerConfig: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/Y",
      },
    };
  },
  computed: {
    overallData() {
      return this.$store.getters.getOverallData;
    },
    monthlyData() {
      return this.$store.getters.getMonthlyData;
    },
    dailyData() {
      return this.$store.getters.getDailyData;
    },
    rangeData() {
      return this.$store.getters.getRangeData;
    },
  },
  components: {
    CardsPage,
    flatPickr,
  },
  methods: {
    async generateRangeReport() {
      if (!this.rangeStartDate || !this.rangeEndDate) {
        return;
      }
      // Format dates as YYYY-MM-DD (flatpickr with dateFormat: "Y-m-d" returns this format)
      const start = this.rangeStartDate;
      const end = this.rangeEndDate;
      this.generatingRange = true;
      try {
        await this.$store.dispatch("RANGE_DATA_REQUEST", { start, end });
      } catch (error) {
        this.$vs.notify({
          title: "Erreur",
          text: "Erreur lors de la génération du rapport",
          color: "danger",
          position: "top-center",
        });
      } finally {
        this.generatingRange = false;
      }
    },
  },
  async beforeMount() {
    await this.$store.dispatch("OVERALL_DATA_REQUEST");
    this.show_analytics = true;
    this.$store.dispatch("OVERALL_BENEF_PAYMENTS_REQUEST");
    this.$store.dispatch("MONTHLY_DATA_REQUEST");
    this.$store.dispatch("DAILY_DATA_REQUEST");
  },
};
</script>

<style scoped>
/* Style flatpickr visible input to match vs-input appearance */
.mt-4 >>> .form-control.input {
  padding: 0.7rem !important;
  font-size: 1rem !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  border-radius: 5px !important;
  width: 100% !important;
  background-color: #fff !important;
  color: rgba(0, 0, 0, 0.87) !important;
  transition: all 0.25s ease !important;
  height: auto !important;
  line-height: normal !important;
}

.mt-4 >>> .form-control.input:hover {
  border-color: rgba(0, 0, 0, 0.4) !important;
}

.mt-4 >>> .form-control.input:focus {
  border-color: rgba(var(--vs-primary), 1) !important;
  outline: none !important;
  box-shadow: 0 0 0 0.2rem rgba(var(--vs-primary), 0.25) !important;
}

.mt-4 >>> .form-control.input::placeholder {
  color: rgba(0, 0, 0, 0.4) !important;
}
</style>
